import { render, staticRenderFns } from "./CustomerCreate.vue?vue&type=template&id=67c83782&"
import script from "./CustomerCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerCreate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreate.vue?vue&type=style&index=0&id=67c83782&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports